"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var stompProtocolV1_0_1 = require("./stompProtocolV1_0");
var stompProtocolV1_1_1 = require("./stompProtocolV1_1");
var stompProtocolV1_2_1 = require("./stompProtocolV1_2");
exports.VERSIONS = {
    V1_0: '1.0',
    V1_1: '1.1',
    V1_2: '1.2',
    // Versions of STOMP specifications supported
    supportedVersions: function () { return '1.2,1.1,1.0'; },
    supportedProtocols: function () { return ['v10.stomp', 'v11.stomp', 'v12.stomp']; }
};
// STOMP protocol with the version in parameter
var stompProtocol = function (version) {
    if (version === void 0) { version = exports.VERSIONS.V1_0; }
    var currentProtocol;
    switch (version) {
        case exports.VERSIONS.V1_2: {
            currentProtocol = stompProtocolV1_2_1.default();
            break;
        }
        case exports.VERSIONS.V1_1: {
            currentProtocol = stompProtocolV1_1_1.default();
            break;
        }
        case exports.VERSIONS.V1_0: {
            currentProtocol = stompProtocolV1_0_1.default();
            break;
        }
        default: {
            throw "Unsupported version : " + version + " ! Versions supported are : " + exports.VERSIONS.supportedVersions();
        }
    }
    // [CONNECTED Frame](http://stomp.github.com/stomp-specification-1.1.html#CONNECTED_Frame)
    var connect = function (headers) {
        return currentProtocol.connect(__assign({}, headers, { 'accept-version': exports.VERSIONS.supportedVersions() }));
    };
    return __assign({}, currentProtocol, { connect: connect });
};
exports.default = stompProtocol;
